export { default } from './MapPageMeta';
